import {
  client,
  ProgramExtendPayload,
  UpdateProgramRequest,
} from "../../../lib/api";
import { calculateEndDate } from "./createProgram";

export async function extendProgram(
  payload: ProgramExtendPayload,
): Promise<void> {
  const endDate = calculateEndDate(
    payload.numberOfSessions,
    payload.notificationDays as number[], // is validated in backend before reaching this method TODO: Inspect why payload array is any[]
    new Date(),
  ).toISOString();
  await client.programs.patchPrograms({
    id: payload.id,
    requestBody: { endDate } satisfies UpdateProgramRequest,
  });
}
